export const ACTIONS = {
    FILTER_SUBSIDIARIES: 'sales/FILTER_SUBSIDIARIES'
};

export default ACTIONS;
